import RegularText from '@/components/RegularText';
import { Touchpoint } from '@/constants/enum';
import { PATH } from '@/constants/path';
import useTrackTouchpoint from '@/hooks/useTrackTouchpoint';
import useUserPlan from '@/hooks/useUserPlan';
import { Link } from '@shopify/polaris';
import { useNavigate } from 'react-router-dom';

interface IProps {
  touchPoint?: Touchpoint;
  text: React.ReactNode;
  isVisible?: boolean;
}

const UpgradeTextWithTouchPoint = ({ text, touchPoint, isVisible }: IProps) => {
  const { isFreePlan } = useUserPlan();
  const navigate = useNavigate();
  const trackTouchPoint = useTrackTouchpoint();
  const isShow = isVisible !== undefined ? isVisible : isFreePlan;

  return isShow ? (
    <RegularText tone="base">
      Available in{' '}
      <Link
        onClick={() => {
          if (touchPoint) {
            trackTouchPoint(touchPoint);
          }
          navigate(PATH.PRICING_PLAN);
        }}
      >
        {text}
      </Link>
    </RegularText>
  ) : null;
};

export default UpgradeTextWithTouchPoint;
